var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"value":_vm.value === 'active',"active-text":"展示","inactive-text":"隐藏"},on:{"change":_vm.confirmChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }